// extracted by mini-css-extract-plugin
export default {"cls1":"PaymentChannelDisabled-MessageContent_cls1__VJkdT","cls2":"PaymentChannelDisabled-MessageContent_cls2__yUihd PaymentChannelDisabled-MessageContent_cls1__VJkdT"};